<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            户口办理进度查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="handlingId" clearable label="身份证号:" placeholder="请输入身份证号"/>
            <van-field label="姓名:" v-model="name" placeholder="请输入姓名"/>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-for="(item, index) in dataList" :key="index" v-if="listShow">
            <div class="boxList-item">
                <span>业务名称:</span>
                <span>{{item.sxmc}}</span>
            </div>
            <div class="boxList-item">
                <span>申请人:</span>
                <span>{{item.sqrxm}}</span>
            </div>
            <div class="boxList-item">
                <span>身份证号:</span>
                <span>{{item.sqrgmsfhm}}</span>
            </div>
            <div class="boxList-item">
                <span>办理状态:</span>
                <span>{{item.spzt}}</span>
            </div>
            <div class="boxList-item">
                <span>受理时间:</span>
                <span>{{item.slsj}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import { idCardRegex } from '@/utils/regex'
    import { getSimpleDate } from '@/views/user/electronicCertificate/utils/birthday'
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "Household",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                show: false,
                handlingId: '', // 身份证号
                name: '',
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                spztMap: {
                    '0':'预审核',
                    '1':'未受理',
                    '2':'未办理',
                    '3':'通过办结',
                    '4':'审核不通过'
                },
                listShow: true,
                dataList: []
            }
        },
        mounted(){
          this.logger.visit('502','0')
        },
        methods: {
            onConfirm(value) {
                this.value = value;
                this.showPicker = false;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

          submit() {
            if (!this.handlingId) {
              Toast('请输入身份证号')
            } else if(!idCardRegex(this.handlingId)) {
              Toast('请输入正确的身份证号')
            } else {
              this.show=true
            }
          },

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                idNum: this.handlingId,
                name: this.name,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.hzTaskStatus}`, data)
              this.show = false
              //关闭加载
              Toast.clear()
              if (res.data.succ) {
                const data = res.data.data
                if(data.length > 0) {
                  data.forEach(obj=>{
                    if(obj.slsj) {
                      obj.slsj = getSimpleDate(obj.slsj)
                    }
                    obj.spzt = this.spztMap[obj.spzt]
                  })
                  this.dataList = Object.assign([], data)
                } else {
                  Toast.fail('未查询到相关数据')
                }
              } else {
                Toast.fail(res.data.msg)
              }
            } catch (error) {
              // Toast.fail('服务器运行失败，请稍后再试。')
                Toast.fail('服务维护中，给您带来的不便进请原谅！')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            idNum: this.handlingId,
                            name: this.name,
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.hzTaskStatus}`, data)
                        //关闭加载
                        Toast.clear()
                        //刷新验证码
                        this.$refs.childFunction.interactionVerificationCode()
                        if (res.data.succ) {
                            const data = res.data.data
                            if(data.length > 0) {
                                data.forEach(obj=>{
                                    if(obj.slsj) {
                                        obj.slsj = getSimpleDate(obj.slsj)
                                    }
                                    obj.spzt = this.spztMap[obj.spzt]
                                })
                                this.dataList = Object.assign([], data)
                            } else {
                                Toast.fail('未查询到相关数据')
                            }
                        } else {
                            Toast.fail(res.data.succ)
                        }
                    } catch (error) {
                        // Toast.fail('服务器运行失败，请稍后再试。')
                        Toast.fail('服务维护中，给您带来的不便进请原谅！')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
